import { Grid } from '@mui/material';
import { Fragment } from 'react';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { RenderInputByTypeMobile } from '../../../components/formGroupGenerator/RenderInputByTypeMobile';
import { mesesEnum } from '../../MisVisitas/constants';

export const ConformidadesFilters = ({
    delegaciones = [],
    metodos = [],
    filters,
    handleSearch,
    handleChangeFilters,
    disableFilters
}) => {

    const aniosOptions = Array.from({ length: 10 }, (_, i) => {
        const year = new Date().getFullYear() - i;
        return { id: year, displayName: year };
    });

    return (
        <>
            <Grid
                container
                spacing={2}
                sx={{ marginBottom: '25px' }}
            >
                <Fragment>
                    <Grid size={{ xs: 12, sm: 6, md: 4, lg: 2, xl: 3 }}>
                        <RenderInputByTypeMobile
                            input={{
                                type: 'select',
                                displayName: 'Delegación',
                                name: 'idDelegacion',
                                options: delegaciones,
                                key: `${filters?.idDelegacion}-delegacion`,
                                disabled: disableFilters
                            }}
                            value={filters.idDelegacion}
                            handleChange={handleChangeFilters}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 3, lg: 2, xl: 2 }}>
                        <RenderInputByTypeMobile
                            input={{
                                type: 'string',
                                displayName: 'Buscar',
                                name: 'txtFiltro',
                                key: `${filters?.txtFiltro}-txtFiltro`,
                                disabled: disableFilters
                            }}
                            value={filters.txtFiltro}
                            handleChange={handleChangeFilters}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 2, lg: 2, xl: 2 }}>
                        <RenderInputByTypeMobile
                            input={{
                                type: 'select',
                                displayName: 'Método',
                                name: 'idMetodo',
                                options: metodos,
                                key: `${filters?.idMetodo}-idMetodo`,
                                disabled: disableFilters
                            }}
                            value={filters.idMetodo}
                            handleChange={handleChangeFilters}
                        />
                    </Grid>
                    <Grid size={{ xs: 6, md: 3, lg: 1.5, xl: 1.5 }}>
                        <RenderInputByTypeMobile
                            input={{
                                type: 'select',
                                displayName: 'Mes',
                                options: mesesEnum.map(x => ({ id: x.value, displayName: x.name })),
                                name: 'mes',
                                disabled: disableFilters
                            }}
                            value={filters.mes}
                            handleChange={handleChangeFilters}
                        />
                    </Grid>
                    <Grid size={{ xs: 6, md: 3, lg: 1.5, xl: 1.5 }}>
                        <RenderInputByTypeMobile
                            input={{
                                type: 'select',
                                displayName: 'Año',
                                options: aniosOptions,
                                name: 'anio',
                                disabled: disableFilters
                            }}
                            value={filters.anio}
                            handleChange={handleChangeFilters}
                        />
                    </Grid>
                    <Grid sx={{ textAlign: 'right' }} size={{ xs: 6, sm: 6, md: 2, lg: 2, xl: 2 }}>
                        <CustomButton
                            variant='contained'
                            onClick={() => handleSearch()}
                            size='small'
                            disabled={disableFilters}
                        >
                            Buscar
                        </CustomButton>
                    </Grid>
                </Fragment>
            </Grid>
        </>
    )
}